import type { Price } from '@personly/libs-types';

interface Props {
  price: Price;
}

const Price = ({ price }: Props) => (
  <>
    {price.value.toFixed(3)} {price.quote.assetHandle}
  </>
);

export default Price;
